import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { loginErr } from "../../api/account/loginApi";
import Logo from "../../assets/chargingadda-logo.png";
import "./LoginPage.scss";

const AUTH_URL = process.env.REACT_APP_AUTH_URL || "https://authz-api.cms.chargingadda.com";

/**
 * Landing of the member invite email (Zitadel links here:
 * /accept-invite?user=<id>&code=<code>). The invitee picks a password and is
 * sent to sign in.
 */
const AcceptInvite: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const userId = params.get("user") || params.get("userID") || "";
  const code = params.get("code") || "";

  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pw.a.length < 8) return setError("Use at least 8 characters.");
    if (pw.a !== pw.b) return setError("Passwords do not match.");
    setBusy(true);
    setError("");
    try {
      await axios.post(`${AUTH_URL}/login/invite/accept`, { user_id: userId, code, new_password: pw.a });
      setDone(true);
    } catch (err) {
      setError(loginErr(err, "Could not accept the invite").message);
    } finally {
      setBusy(false);
    }
  };

  const invalid = !userId || !code;

  return (
    <div className="lgn-page">
      <div className="lgn-card">
        <img className="lgn-brand" src={Logo} alt="ChargingAdda" />
        {invalid ? (
          <>
            <h1 className="lgn-title">Invalid invite link</h1>
            <p className="lgn-sub">This link is incomplete. Ask your administrator to resend the invite.</p>
          </>
        ) : done ? (
          <>
            <h1 className="lgn-title">You're all set</h1>
            <p className="lgn-sub">Your password is saved. Sign in to open the dashboard.</p>
            <button className="lgn-btn lgn-btn--primary" onClick={() => navigate("/login")}>Sign in</button>
          </>
        ) : (
          <form className="lgn-form" onSubmit={submit}>
            <div>
              <h1 className="lgn-title">Welcome to ChargingAdda</h1>
              <p className="lgn-sub">You've been invited to the dashboard. Choose a password to finish setting up your account.</p>
            </div>
            <label>
              Password
              <input type="password" autoFocus autoComplete="new-password" minLength={8} value={pw.a}
                     onChange={(e) => setPw({ ...pw, a: e.target.value })} required />
            </label>
            <label>
              Confirm password
              <input type="password" autoComplete="new-password" minLength={8} value={pw.b}
                     onChange={(e) => setPw({ ...pw, b: e.target.value })} required />
            </label>
            {error && <div className="lgn-error">{error}</div>}
            <button className="lgn-btn lgn-btn--primary" type="submit" disabled={busy}>
              {busy ? "Saving..." : "Create account"}
            </button>
          </form>
        )}
        <div className="lgn-foot">Secured by ChargingAdda</div>
      </div>
    </div>
  );
};

export default AcceptInvite;
